module.exports = __webpack_public_path__ + "media/images/lock-df5de10bca9e65bd1f03043bce2e855e.svg";